import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        image: '/images/service/icon-01.png',
        title: 'Cyber Security Services',
        description: 'Cyber security services provide comprehensive protection and defense against potential threats, vulnerabilities, and attacks.'
    },
    {
        image: '/images/service/icon-02.png',
        title: 'IT Infrastructure Services',
        description: "IT infrastructure services manage and optimize an organization's technology systems to enhance performance, security, and scalability."
    },
    {
        image: '/images/service/icon-03.png',
        title: 'Governance, Risk & Compliance (GRC) Services',
        description: 'GRC services assist organizations in risk management, regulatory compliance, and governance practices.'
    }
]
const ServiceThree = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="image">
                                    <img src={`${val.image}`} alt="card Images" />
                                </div>
                                <div className="content">
                                    <h4 className="title"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                    <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceThree;